import React, { useMemo } from "react";
import styled from "@emotion/styled";

import AreaTypes from "types/AreaTypes";
import PointTypes from "types/PointTypes";
import PathTypes from "types/PathTypes";
import DisplayTypes from "types/DisplayTypes";

import ParkkiTheme from "themes/ParkkiTheme";

const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: smaller;
`;

const Label = styled.div`
  margin-left: ${ParkkiTheme.spacings.teeny};
`;

type Props = {
  getIcon?: Function;
  label?: string;
  layer: AreaTypes | PathTypes | PointTypes | DisplayTypes;
};

function MapLabel({ layer, getIcon, label }: Props): JSX.Element | null {
  const Icon = useMemo(() => {
    function handleGetIcon(
      layer: AreaTypes | PathTypes | PointTypes | DisplayTypes
    ) {
      if (getIcon) {
        return getIcon(layer);
      }
      return null;
    }

    return handleGetIcon(layer);
  }, [getIcon, layer]);

  if (!label && !Icon) {
    return null;
  }

  if (!Icon) {
    return <>{label}</>;
  }

  if (!label) {
    return (
      <LabelContainer>
        <Icon fontSize="small" />
      </LabelContainer>
    );
  }

  return (
    <LabelContainer>
      <Icon fontSize="small" />
      <Label>{label}</Label>
    </LabelContainer>
  );
}

export default MapLabel;
